export default __webpack_public_path__ + "static/media/docker.3253a6fe.svg";